module.exports = __webpack_public_path__ + "r-v3/img/beta_blue.db2c9d29.svg";